import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoadingPage from './pages/LoadingPage';
import SignInPage from './pages/SignInPage';
import RegistrationPage from './pages/RegistrationPage';
import SuccessPage from './pages/SuccessPage';
import OnboardingPage from './pages/OnboardingPage';
import DashboardLayout from './components/layout/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import ProgressPage from './pages/ProgressPage';
import DocumentsPage from './pages/DocumentsPage';
import ApplicationFormPage from './pages/ApplicationFormPage';
import ProfilePage from './pages/ProfilePage';

function AppRouter() {
  const { authState } = useAuth();

  if (authState === 'loading' || authState === 'checking') {
    return <LoadingPage />;
  }

  if (authState === 'unauthenticated') {
    return <SignInPage />;
  }

  if (authState === 'not_found') {
    return <RegistrationPage />;
  }

  if (authState === 'registered') {
    return <SuccessPage />;
  }

  // authState === 'needs_onboarding' or 'found'
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/application" element={<ApplicationFormPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
